import {
  Box,
  Button,
  Card,
  CardContent,
  Rating,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import { allIcons } from "../../assets";
import appcolors from "../../constants/Colors";

const TeamCard = ({ item }) => {
  return (
    <Card
      sx={{
        minWidth: 290,
        maxWidth: 290,
        margin: "16px",
        border: `1px solid ${appcolors.borderColor}`,
        height: "100px",
      }}
    >
      <CardContent>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              height: "40px",
              width: "40px",
              overflow: "hidden",
              borderRadius: "50%",
            }}
          >
            <img
              src={item.image}
              alt={item.name}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </Box>
          <Box
            sx={{
              marginLeft: "16px",
            }}
          >
            <Typography
              variant="h6"
              fontSize={12}
              sx={{ fontWeight: "bold", color: appcolors.black }}
            >
              {item.firstname} {item.lastname}
            </Typography>
            <Typography variant="body2" sx={{ color: appcolors.lightText }}>
              {item.title}
            </Typography>
            <Typography variant="body2" sx={{ color: appcolors.lightText }}>
              Title
            </Typography>
          </Box>
        </Box>

        <Typography variant="body2" sx={{ color: appcolors.lightText }}>
          {`${item?.notes.slice(0, 80)}...`}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default TeamCard;
